import React from 'react';
import {Link,useNavigate} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiHome,FiBrick,FiLayers,FiSquare,FiTool,FiGrid,FiArrowRight}=FiIcons;

const Services=()=> {
  const navigate=useNavigate();
  
  const services=[
    {
      title: 'Rohbau',
      path: '/leistungen/rohbau',
      icon: FiHome,
      description: 'Fundamente, Mauerwerk und Betonarbeiten - das solide Grundgerüst für Ihr Bauvorhaben.',
      features: ['Fundamente','Mauerwerk','Betonarbeiten']
    },
    {
      title: 'Klinkerarbeiten',
      path: '/leistungen/klinkerarbeiten',
      icon: FiBrick,
      description: 'Hochwertige Klinkerverblendungen für langlebige und ästhetische Fassaden.',
      features: ['Klinkerfassaden','Verblendmauerwerk','Restaurierung']
    },
    {
      title: 'Putzarbeiten',
      path: '/leistungen/putzarbeiten',
      icon: FiLayers,
      description: 'Innen- und Außenputz für perfekte Oberflächengestaltung in verschiedenen Ausführungen.',
      features: ['Innenputz','Außenputz','Dekorputz']
    },
    {
      title: 'Betonarbeiten',
      path: '/leistungen/betonarbeiten',
      icon: FiSquare,
      description: 'Fundamente, Bodenplatten und Betonkonstruktionen in höchster Qualität.',
      features: ['Betonfundamente','Bodenplatten','Stützmauern']
    },
    {
      title: 'Maurerarbeiten',
      path: '/leistungen/maurerarbeiten',
      icon: FiTool,
      description: 'Traditionelles Handwerk mit modernen Techniken für alle Maurerarbeiten.',
      features: ['Mauerwerksbau','Reparaturen','Sanierung']
    },
    {
      title: 'Pflasterverlegung',
      path: '/leistungen/pflasterverlegung',
      icon: FiGrid,
      description: 'Professionelle Verlegung für Einfahrten, Gehwege und Terrassen.',
      features: ['Einfahrten','Gehwege','Terrassen']
    }
  ];

  const handleServiceClick=(e,path)=> {
    e.preventDefault();
    // Scrollt sofort nach oben
    window.scrollTo(0,0);
    // Kurz danach zur Seite navigieren
    setTimeout(()=> {
      navigate(path);
    },50);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Elfsight Slider Section */}
        <div className="mb-20">
          <div class="elfsight-app-8b479b08-7208-45db-9dde-01e55f897760" data-elfsight-app-lazy></div>
        </div>

        <div className="text-center mb-16">
          <motion.div 
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Unsere Leistungen
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Vom Fundament bis zum letzten Stein - wir bieten Ihnen das komplette Spektrum moderner Bauarbeiten mit höchsten Qualitätsstandards.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.map((service,index)=> (
            <motion.div 
              key={service.title}
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.8,delay: index * 0.1}}
              className="group"
            >
              <Link 
                to={service.path}
                onClick={(e)=> handleServiceClick(e,service.path)}
                className="block"
              >
                <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl transition-all duration-300 group-hover:border-[#3466ad]/30 h-full">
                  <div className="flex items-center space-x-4 mb-6">
                    <div className="w-14 h-14 bg-gradient-to-br from-[#3466ad] to-[#2a5291] rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <SafeIcon icon={service.icon} className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 group-hover:text-[#3466ad] transition-colors">
                      {service.title}
                    </h3>
                  </div>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  <ul className="space-y-2 mb-6">
                    {service.features.map((feature,idx)=> (
                      <li key={idx} className="flex items-center space-x-2 text-gray-600">
                        <div className="w-2 h-2 bg-[#3466ad] rounded-full"></div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="flex items-center text-[#3466ad] font-medium group-hover:translate-x-2 transition-transform duration-300">
                    <span>Mehr erfahren</span>
                    <SafeIcon icon={FiArrowRight} className="w-4 h-4 ml-2" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8,delay: 0.3}}
          className="text-center"
        >
          <Link 
            to="/leistungen" 
            className="inline-flex items-center space-x-2 bg-[#3466ad] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#2a5291] transition-colors duration-200 shadow-lg hover:shadow-xl"
            onClick={(e)=> handleServiceClick(e,'/leistungen')}
          >
            <span>Alle Leistungen anzeigen</span>
            <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;